import React from "react";
import Card from "react-bootstrap/Card";
import { ImCircleRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
           I'm a <span className="purple">Full Stack Engineer</span> with <span className="purple"> DevOps</span> expertise, completed my Bachelors in Computer Sciences from Comsats University Islamabad
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImCircleRight />&nbsp; Playing Games
            </li>
            <li className="about-activity">
              <ImCircleRight />&nbsp; Writing Tech Blogs
            </li>
          </ul>

          <p style={{ color: "#62a9df" }}>
            "You don't have to be great to start, but you have to start to be great."{" "}
          </p>
          <footer className="blockquote-footer">Zig Ziglar</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
